const carouselItems = [
  {
    title: '暑期档观影指南',
    desc: '2026年暑期档大片云集，从国产科幻到好莱坞巨制，这份观影指南帮你规划最佳看片顺序，不错过任何一部好片。',
    tag: '编辑精选',
    img: 'https://readdy.ai/api/search-image?query=Summer%20cinema%20abstract%20visual%20warm%20sunset%20golden%20light%20film%20reels%20floating%20dark%20background%20cinematic%20atmosphere%20elegant%20composition%20no%20text&width=1000&height=500&seq=carousel-01&orientation=landscape',
  },
  {
    title: '张国荣经典回顾',
    desc: '重温「哥哥」不朽银幕传奇，《霸王别姬》《阿飞正传》《春光乍泄》等经典影片4K修复版已上线，每一部都是华语电影的瑰宝。',
    tag: '经典专题',
    img: 'https://readdy.ai/api/search-image?query=Nostalgic%20classic%20Chinese%20cinema%20abstract%20visual%20warm%20vintage%20tones%20old%20film%20texture%20dramatic%20lighting%20dark%20background%20elegant%20artistic%20composition%20no%20text&width=1000&height=500&seq=carousel-02&orientation=landscape',
  },
  {
    title: '悬疑烧脑电影合集',
    desc: '十部高能反转悬疑片一次推荐，从国产精品到海外佳作，每一部都让你猜不到结局。烧脑爱好者不可错过的片单。',
    tag: '主题片单',
    img: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20cinematic%20abstract%20visual%20dark%20moody%20atmosphere%20dramatic%20shadows%20warm%20accent%20lighting%20film%20noir%20style%20artistic%20composition%20no%20text&width=1000&height=500&seq=carousel-03&orientation=landscape',
  },
  {
    title: '2026夏季新番专题',
    desc: '最新日漫国漫夏季新番同步上线！从热血战斗到治愈日常，精选本季最值得追的动画作品，二次元爱好者必看。',
    tag: '动漫新番',
    img: 'https://readdy.ai/api/search-image?query=Anime%20style%20abstract%20visual%20vibrant%20colors%20dynamic%20composition%20warm%20lighting%20dark%20background%20artistic%20illustration%20cinematic%20feel%20no%20text&width=1000&height=500&seq=carousel-04&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="relative py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-50 mb-3">焦点专题</h2>
          <p className="text-foreground-500 max-w-lg mx-auto">深度策划影视专题，发现更多精彩内容</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-6">
          {carouselItems.map((item, idx) => (
            <div key={idx} className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/50 hover:border-primary-500/20 transition-all duration-300 cursor-pointer">
              <div className="relative h-48 md:h-56 overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1 rounded-md bg-primary-500/90 text-background-50 text-xs font-medium">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="text-foreground-100 font-semibold text-base md:text-lg mb-2">{item.title}</h3>
                <p className="text-foreground-500 text-sm leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}